$(function($){

  // Add class to body
  $('body').addClass('doc-ready');

  // Hidden menu
  $('.mobile-menu-btn').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('is-open');
    $('.main-menu').toggleClass('is-open');
    $('body').toggleClass('overflow-hidden');
  });


	$('.search, .close-search').on('click', function(e) {
		e.preventDefault();

		$('.search-form').fadeToggle();
	});

  if ($(window).width() < 992) {
    $('.has-dd > a').on('click', function(e) {
      e.preventDefault();
      $(this).closest('.has-dd').toggleClass('is-open');
    });

	  const $header = $('.page-header');

	  let lastScroll = 0;

	  $(window).on('scroll', () => {
		  let currentScroll = $(window).scrollTop();

		  if (currentScroll > lastScroll) {
			  $header.removeClass('scroll-up').addClass('scroll-down');
		  } else {
			  $header.removeClass('scroll-down').addClass('scroll-up');
		  }

		  lastScroll = currentScroll;
	  });
  }

	if ($('.hero-section').hasClass('bg-purple') || $('.hero-section').hasClass('landing2-hero-section')) {
		const changeLogo = () => {
			console.log('here');
			const whiteLogo = $('.logo-footer img').attr('src');
			const blackLogo = whiteLogo.split('_white')[0] + '.svg';

			const windowWidth = $(window).width();
			if (windowWidth >= 992) {
				$('.page-header .logo img').attr('src', whiteLogo);
			} else {
				$('.page-header .logo img').attr('src', blackLogo);
			}
		};

		changeLogo();

		let isLargeScreen = $(window).width() >= 992;

		$(window).on('resize', function() {
			const newIsLargeScreen = $(window).width() >= 992;
			if (isLargeScreen !== newIsLargeScreen) {
				isLargeScreen = newIsLargeScreen;
				changeLogo();
			}
		});
	}

});
